import useTypedContext from "hooks/useTypedContext";
import PageInfoHeader from "ds/components/PageInfoHeader";

import ProviderVersionArtifacts from "../ProviderVersionArtifacts";
import { TerraformProviderVersionWithArtifacts } from "../types";
import { ProviderVersionDocsContext } from "./Context";

const ProviderVersionDocsAssets = () => {
  const { provider, version } = useTypedContext(ProviderVersionDocsContext);

  const versionWithArtifacts: TerraformProviderVersionWithArtifacts = {
    id: version.id,
    description: version.description,
    number: version.number,
    status: version.status,
    allowedActions: version.allowedActions,
    artifacts: version.artifacts,
    docs: { overviewContent: version.docs.overviewContent ?? "" },
  };

  return (
    <>
      <PageInfoHeader title="Assets" />
      <ProviderVersionArtifacts version={versionWithArtifacts} provider={provider} simple />
    </>
  );
};

export default ProviderVersionDocsAssets;
